module.exports = __webpack_public_path__ + "media/images/illustrations/skieio_trimmed-64f3b2617728c94a9ad1de73a3984578.png";